import { useCallback, useEffect, useRef, useState } from 'react';

import { observer } from 'mobx-react-lite';
import { userSettingsStore } from '../../store/userSettingsStore';
import { applicationStore } from '../../store/applicationStore';
import {
  getBrowserVisibilityProp,
  getIsDocumentHidden,
} from '../../core/helpers/documentVisibility';
import { SoundTypesByGame } from '../../core/constants/soundOptionsByGame';
import { soundService } from '../../services/baseSoundService/soundService';

const useUpdateEffect = (func, dep) => {
  const ref = useRef(false);
  useEffect(() => {
    if (ref.current) func();
    else ref.current = true;
    // eslint-disable-next-line
  }, dep);
};

export const SoundWatcher = observer(() => {
  const { isMusicOn, isSoundOn } = userSettingsStore;
  const { isSoundsLoaded, isConnectionLost } = applicationStore;
  const [isClickedDocument, setIsClickedDocument] = useState(false);
  const handleDocumentClick = useCallback(() => {
    soundService
      .play(SoundTypesByGame[window.location.pathname]?.bgMusic, true)
      .then((isPlayed) => {
        setIsClickedDocument(true);
        document.removeEventListener('click', handleDocumentClick);
        if (!isPlayed) {
          setTimeout(() => {
            soundService.play(SoundTypesByGame[window.location.pathname]?.bgMusic, true);
          }, 1000);
        }
      });

    // if (!isMusicOn) {
    //   soundService.muteMusic(true); // this condition creates issue when first click is music icon
    // }
  }, []);

  useEffect(() => {
    document.addEventListener('click', handleDocumentClick);
    return () => {
      document.removeEventListener('click', handleDocumentClick);
    };
    // eslint-disable-next-line
  }, [isConnectionLost]);

  const playMusic = () => {
    if (isClickedDocument) {
      setIsClickedDocument(true);
    }
    document.removeEventListener('click', playMusic);
  };

  useUpdateEffect(() => {
    soundService.muteMusic(true);
    soundService.muteSounds(true);
    soundService.muteMusic(!isMusicOn);
    soundService.muteSounds(!isSoundOn);
    // eslint-disable-next-line
  }, [isSoundsLoaded]);

  useUpdateEffect(() => {
    document.addEventListener('click', playMusic);
  }, [isMusicOn, isClickedDocument]);

  const onVisibilityChange = () => {
    if (!getIsDocumentHidden()) {
      soundService.pauseMusic();
      soundService.pauseSounds();
      soundService.muteSounds(true);
    } else {
      soundService.resumeMusic();
      soundService.muteSounds(!isSoundOn);
    }
  };

  useEffect(() => {
    return () => {
      soundService.stopAll();
      document.removeEventListener('click', playMusic);
    };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const visibilityChange = getBrowserVisibilityProp();

    document.addEventListener(visibilityChange, onVisibilityChange, false);

    return () => {
      document.removeEventListener(visibilityChange, onVisibilityChange);
    };
    // eslint-disable-next-line
  }, [isMusicOn, isSoundOn]);

  useEffect(() => {
    if (isConnectionLost) {
      soundService.pauseMusic();
      soundService.pauseSounds();
    } else {
      soundService.resumeMusic();
    }
  }, [isConnectionLost]);

  return null;
});
